import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {ModalService} from '../../shared/services/modal.service';
import {AdminService} from '../../shared/services/admin.service';
import {DomainService} from '../../shared/services/domain.service';
import {InterestService} from '../../shared/services/interest.service';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {empty} from '../../functions';
import {ModalAdminStudentprofileComponent} from '../admin-studentprofiles/modal-admin-studentprofile/modal-admin-studentprofile.component';
import {ModalAdminTeacherprofileComponent} from './modal-admin-teacherprofile/modal-admin-teacherprofile.component';
import {TeacherService} from '../../shared/services/teacher.service';

@Component({
    selector: 'app-admin-teacherprofiles',
    templateUrl: './admin-teacherprofiles.component.html',
    styleUrls: ['./admin-teacherprofiles.component.scss'],
    standalone: false
})
export class AdminTeacherprofilesComponent implements OnInit {

  public view = {
    filters: {
      areaOfInterests: <string[]>[],
      educationareaOfInterests: [],
      lookingFor: '',
      sites: <any>[]
    },filterOptions: {
      areaOfInterests: <any> [],
      sites: <any> []
    }
  };

  public configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: 'First name',
        name: 'firstName',
        type: 'text'
      },
      {
        header_name: 'Last name',
        name: 'lastName',
        type: 'text'
      },
      {
        header_name: 'City',
        name: 'address',
        subName: 'city',
        type: 'text'
      },
      {
        header_name: 'Country',
        name: 'address',
        subName: 'country',
        type: 'text'
      },

    ],
    endpoint: 'teacherprofile',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'View'
      },
    ],
    class: '',
    reloadListener: new Subject()

  };

  /**
   * Constructor
   *
   * @param interests
   */
  constructor(public modal:ModalService,
              private adminService: AdminService,
              private teacherService: TeacherService,
              private domain: DomainService,
              public interest: InterestService,
              private alertService: AlertService) {


  }

  /**
   * Ng on init
   */
  ngOnInit(): void {


    // Set area of interest filter options
    this.interest.apiGetAreaOfInterests().subscribe( (result:any) => {
      if (!empty(result)) {
        result.data.map( (item:any) => {
          this.view.filterOptions.areaOfInterests.push({value: item.id, label: item.name});
        });
      }
    });

    // Set site filter options
    const sites = this.domain.getAllDomains();
    if (!empty(sites)) {

      sites.map( (item:any) => {
        this.view.filterOptions.sites.push({value: item.id, label: item.url + ' (' + item.code + ')'});
      });

    }

  }
  /**
   * Delete a single student profile
   *
   * @param id
   */
  updateTeacherprofile($data:any) {

    const modalOptions = {
      backdrop: 'static',
      size: 'lg'
    };

    const data = {
      entity: $data
    };

    this.modal.Modal(ModalAdminTeacherprofileComponent, '', '', data, [], modalOptions).then( (result) => {

      if (result === true) {

        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });

  }


  /**
   * Delete a single student profile
   *
   * @param id
   */
  deleteTeacherprofile(id:string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then( (confirm) => {
      if (confirm === true) {

        this.teacherService.apiDeleteTeacherprofile(id).subscribe( (result) => {

          // Reload data
          this.configTable.reloadListener.next(true);

        });

      }
    }).catch( (error) => {

    });

  }

  /**
   * Handle table button event
   *
   * @param $event
   */
  handleButtonEvent($event:any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'delete':
          this.deleteTeacherprofile($event['data']['id']);
          break;

        case 'edit':
          this.updateTeacherprofile($event['data']);
          break;
      }

    }

  }


}
